import React from 'react';
import { MobileStatusBox } from './MobileStatusBox';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
export const MobileExternalViewerPointingDomain = _ref => {
  let datahook = _ref.datahook;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook
  }, t('domains_search_gate.logged_in.mobile.connect.vibe_block.pointing.message'));
};
//# sourceMappingURL=MobileExternalViewerPointingDomain.js.map